import { render, staticRenderFns } from "./ComparaisonBarCard.vue?vue&type=template&id=240132da"
import script from "./ComparaisonBarCard.vue?vue&type=script&lang=js"
export * from "./ComparaisonBarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports